import MetaData from "@components/Modules/MetaData";
import AppNewsletter from "@components/Modules/Newsletter/AppNewsletter";
import SocialMedia from "@components/Modules/SocialMedia/SocialMedia";
import PubBaseLayout from "@pub/BaseLayout";
import { configHeader, configNewsletter, configSite } from "@pub/config";
import { GlobalBaseData } from "@sphtech/dmg-design-system";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import { dataLoader } from "@src/app/utils/dataLoader";
import { ReactElement } from "react";

import styles from "./newslettersignup.module.css";

export const meta = () => {
  return MetaData({
    title: "Newsletter",
    type: "WebPage",
    path: "/newsletter-signup",
  });
};

export default function NewsletterSignupPage(): ReactElement {
  const newsLetterProps = {
    backgroundImage: configNewsletter.image || "",
    newsletterCtaText: configNewsletter.signUpText || "SIGN UP",
    emailPlaceHolder: {
      placeholder: configNewsletter.emailPlaceHolderText || "Email Address",
    },
    newsletterBody: configNewsletter.body || "",
    newsletterTitle: configNewsletter.title || "",
    newsletterLang: configNewsletter.lang || "",
  };
  return (
    <PubBaseLayout ads={false} skipMobileBanner>
      <div className={styles.newsletterOuterContainer}>
        <AppNewsletter {...newsLetterProps} variant="standalone" />

        {configSite.socialMedia && (
          <SocialMedia
            data={configHeader.socialMedia}
            title={configSite.socialMedia.title}
          />
        )}
      </div>
    </PubBaseLayout>
  );
}

export async function loader(): Promise<
  TRouteWithRedirect<GlobalBaseData, GlobalBaseData | string>
> {
  return await dataLoader({
    type: ResponseType.SUCCESS,
    dataSource: {
      type: ResponseType.SUCCESS,
      statusCode: 200,
      payload: {},
    },
  });
}
